/**
 * In this file, we create a React component
 * which incorporates components provided by Material-UI.
 */
import React from "react";
import queryString from "query-string";
import Helmet from 'react-helmet';

import { WithLocalize } from "../../containers/I18nProvider";
import RequestLoginErrorMessage from "../../components/RequestLoginErrorMessage";
import ServiceApi from "../../services/ServiceApi";

import "./style.scss";
import favicon from "./image/icon.png";
import logo from "./image/maxitv.png";
import LoginForm from "./LoginForm";

class Login extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.api = new ServiceApi(this);
    this.parameters = queryString.parse(props.location.search);
    props.changeDefaultLocale('pt-BR');
  }

  _validateParams() {
    if (
      !this.parameters.client_id ||
      !this.parameters.redirect_uri ||
      !this.parameters.response_type
    ) {
      return false;
    }
    return true;
  }

  componentDidMount() {
    document.body.className = "maxitv-body";
    document.title = "MaxiTV - Fox+";
  }

  render() {
    const { translate } = this.props;

    return (
      <div className="maxitv-container">
        <Helmet>
        <link rel="icon" type="image/png" href={favicon} sizes="16x16" />
         </Helmet>
        <div className="maxitv-container-logo">
          <img src={logo} alt="maxitvrtes" className="maxitv-logo" />
        </div>
        <p className='maxitv-title'> Acesse com login da MaxiTV </p>
        {this._validateParams() ? (
          <LoginForm api={this.api} location={this.props.location} />
        ) : (
          <RequestLoginErrorMessage
            onlyMessage={true}
            message={translate("RequestLoginErrorMessage")}
          />
        )}
      </div>
    );
  }
}

export default (WithLocalize(Login));
